import React from "react";

function CheckMarkSvg() {
  return (
    <div>
      <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink">
        <title>59E8A56B-05F0-45D3-9460-DA8D456E5935</title>
        <g id="Mobile" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="04.00---Document-country" transform="translate(-316.000000, -605.000000)">
            <rect fill="#FFFFFF" x="0" y="0" width="375" height="667"></rect>
            <g id="Nationality" transform="translate(20.000000, 183.000000)">
              <g id="Card-UK" transform="translate(0.000000, 395.000000)">
                <rect id="Rectangle" stroke="#DCE1E3" fill="#F8F9F9" x="0.5" y="0.5" width="334" height="77" rx="5"></rect>
                <g id="Ico-ok" transform="translate(296.000000, 27.000000)" fill="#00A4F5" fillRule="nonzero">
                  <path d="M12,0 C18.617,0 24,5.383 24,12 C24,18.617 18.617,24 12,24 C5.383,24 0,18.617 0,12 C0,5.383 5.383,0 12,0 Z M16.47,8.471 L10,14.94 L7.53,12.471 C7.237,12.178 6.763,12.178 6.47,12.471 C6.177,12.764 6.177,13.238 6.47,13.531 L9.47,16.531 C9.616,16.678 9.808,16.751 10,16.751 C10.192,16.751 10.384,16.678 10.53,16.531 L17.53,9.531 C17.823,9.238 17.823,8.764 17.53,8.471 C17.237,8.178 16.763,8.178 16.47,8.471 Z" id="Ico"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div >
  );
}
export default CheckMarkSvg;
